import {
  Box,
  Link
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import { 
  clearFlashNotice,
  clearFlashAlert
} from '../redux/features/ui/uiSlice'
import SignOut from '../redux/features/user/SignOut'

const classes = {
  // Level with the rest of the menu bar, and on one line: pinned to the top it
  // sat higher than everything beside it, and in a narrow window "Sign Out"
  // broke over two lines.
  box: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    fontSize: 14,
  },
  link: {
    margin: '0 5px 0 5px',
    cursor: 'pointer',
  },
}

export default function AuthenticatedNavigation(props) {
  const dispatch = useDispatch()

  const handleLinkClick = (e) => {
    dispatch(clearFlashNotice())
    dispatch(clearFlashAlert())
  }

  return (
    <Box 
      component='span'
      sx={classes.box}
    >
      <Link
        component={RouterLink}
        onClick={handleLinkClick}
        to='/app/account' 
        sx={classes.link} 
        rel='nofollow' 
        color='inherit'
      >
        Account
      </Link>
      <SignOut />
      <Link
        component={RouterLink}
        onClick={handleLinkClick}
        to='/news'
        sx={classes.link}
        color='inherit'
      >
        News
      </Link>
      <Link
        component={RouterLink}
        onClick={handleLinkClick}
        to='/help'
        sx={classes.link}
        color='inherit'
      >
        Help
      </Link>
    </Box>
  )
}
